import { List, Map, OrderedMap } from 'immutable'
import { 
  FETCH_CAMPAIGNS,
  EDIT_CAMPAIGN,
  CREATE_CAMPAIGN,
  DELETE_CAMPAIGN,
  FETCH_DOMAINS,
  FETCH_SERVICES,
  CREATE_SERVICE,
  EDIT_SERVICE,
} from '../actions/ads'

export default function ads(state = {
  campaigns: new List(),
  domains: new List(),
  services: new Map(),
}, action) {
  switch (action.type) {
    case FETCH_CAMPAIGNS:
      return { ...state, 
        campaigns: new List(action.payload.campaigns),
      }
    case CREATE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.push(action.payload.id, action.payload),
      }
    case DELETE_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.delete(state.campaigns.findIndex(v => v.id === action.payload)),
      }
    case EDIT_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.set(
          state.campaigns.findIndex(v => v.id === action.payload.id),
          action.payload
        ),
      }
    case FETCH_DOMAINS:
      return {
        ...state,
        domains: new List(action.payload.domains),
      }
    case FETCH_SERVICES:
      return {
        ...state,
        services: new List(action.payload.ads),
      }
    case CREATE_SERVICE:
      return {
        ...state,
        services: state.services.push(action.payload),
      }
    case EDIT_SERVICE:
      return {
        ...state,
        services: state.services.set(
          state.services.findIndex(v => v.id === action.payload.id),
          action.payload
        ),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ads.js